import { defineStore, storeToRefs } from 'pinia';
import { ref } from 'vue';

export const useContestantImportStore = defineStore('contestantimportstore', () => {
    // If this is set we will show a mapper and try and map the layout from the source event.
    const mapRacecourseLayoutFromEvent = ref<number | null>(null);

    return {
        /**
         * The ID of the event we want to map the racecourse layout from.
         */
        MapSourceEventID: mapRacecourseLayoutFromEvent,
    };
});

export const useContestantImportStoreRef = () => storeToRefs(useContestantImportStore());
